import { useState, useEffect } from 'react';
import SettingsTemplates from './SettingsTemplates';
import './Settings.scss';
import { DotPhrases } from './SettingsDotPhrases';
import { Segmented } from 'antd';
import AmbientAISettings from '../AmbientSettings/Settings';
import { useSearchParams } from 'react-router-dom';
import { usePageHeader } from 'src/hooks/misc/usePageHeader';

const EncounterSettings = () => {
  const isMobile = window.innerWidth < 1260;
  const [searchParams] = useSearchParams();
  const encounterPhaseParam = searchParams.get('encounter-phase');
  const templateOverridesIdParam = searchParams.get('template_overrides_id');

  usePageHeader({
    title: 'Customize',
  });

  const tabs = {
    'pre-chart': {
      label: 'Pre-chart templates',
      component: () => (
        <SettingsTemplates
          key="pre-chart"
          encounterPhase="pre-chart"
          template_overrides_id={templateOverridesIdParam}
        />
      ),
    },
    'in-visit': {
      label: 'In visit templates',
      component: () => (
        <SettingsTemplates
          key="in-visit"
          encounterPhase="in-visit"
          template_overrides_id={templateOverridesIdParam}
        />
      ),
    },
    'after-visit': {
      label: 'Documents',
      component: () => (
        <SettingsTemplates
          encounterPhase="after-visit"
          template_overrides_id={templateOverridesIdParam}
        />
      ),
    },
    'dot-phrases': {
      label: 'Dot phrases',
      component: () => <DotPhrases />,
    },
    ...(isMobile && {
      settings: {
        label: 'Settings',
        component: () => <AmbientAISettings />,
      },
    }),
  };

  const [activeTab, setActiveTab] = useState(
    encounterPhaseParam in tabs ? encounterPhaseParam : 'in-visit'
  );

  const activeTabPane = tabs[activeTab];

  useEffect(() => {
    if (!activeTabPane) {
      setActiveTab('in-visit');
    }
  }, [activeTabPane]);

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <div className={`settings-component page-wrapper`}>
      <div className="flex">
        <Segmented
          value={activeTab}
          options={Object.entries(tabs).map(([key, value]) => ({
            label: value.label,
            value: key,
          }))}
          onChange={handleTabChange}
          style={{
            fontSize: isMobile ? '12px' : '14px',
            textAlign: 'center', // Always center align
          }}
        />
      </div>
      <div>
        <div className="container-width min-h-[50vh] mt-2 py-4 relative ">
          {activeTabPane?.component()}
        </div>
      </div>
    </div>
  );
};

export default EncounterSettings;
